import { useCallback, useEffect, useState } from 'react';

import { validateDecimalInput, validateDigitsInput } from '../../../utils/formatUtils';
import useToast from '../../../hooks/useToast';
import { getOperationalDetails } from '../../../services/workReport';

const useProgramPoint = (props) => {
  const { setFieldValue, values, notificaPorCSA, tipoAsignacion, idParteDiario } = props;
  const { setNewToast } = useToast();
  const [costOptions, setCostOptions] = useState([]);

  const fetchCode = async (val, index) => {
    const body = {
      tipoAsignacion,
      claseCosto: val.costoClase,
      fase: val.fase
      // codigo: 'T',
      // subcodigo: '140'
    };

    const response = await getOperationalDetails(idParteDiario, body);

    const adapterCode = response?.codigo?.map((code, indexCode) => ({
      nombre: code,
      id: indexCode + 1
    }));

    setFieldValue(`programPoints[${index}].optionsCode`, adapterCode);
  };

  const fetchSubCodes = async (val, index) => {
    try {
      const body = {
        tipoAsignacion,
        claseCosto: values?.programPoints[index]?.cost?.costoClase,
        fase: values?.programPoints[index]?.cost?.fase,
        codigo: val.nombre
        // subcodigo: '140'
      };
      const response = await getOperationalDetails(idParteDiario, body);

      const dataFilterSubCode = response?.subcodigo?.map((sub, indexSub) => ({
        nombre: sub,
        id: indexSub + 1
      }));

      setFieldValue(`programPoints[${index}].optionsSubCode`, dataFilterSubCode);
    } catch (error) {
      setNewToast({ type: 'ERROR', message: error.message });
    }
  };

  const fetchCost = async () => {
    try {
      const body = {
        tipoAsignacion
        // claseCosto: 'EQP',
        // fase: '10b',
        // codigo: 'T',
        // subcodigo: '140'
      };

      const response = await getOperationalDetails(idParteDiario, body);

      const adapterData = response?.costoClase?.map((cost) => ({
        ...cost,
        nombreCorto: cost.costoClase,
        nombre: cost.combinacion,
        id: `${cost.costoClase} | ${cost.fase}`
      }));

      setCostOptions(adapterData || []);
    } catch (error) {
      setNewToast({ type: 'ERROR', message: error.message });
    }
  };

  const fetchDetails = async (val, index) => {
    try {
      const body = {
        tipoAsignacion,
        claseCosto: values?.programPoints[index]?.cost?.costoClase,
        fase: values?.programPoints[index]?.cost?.fase,
        codigo: values?.programPoints[index]?.code?.label,
        subcodigo: val?.label
      };
      const response = await getOperationalDetails(idParteDiario, body);

      setFieldValue(`programPoints[${index}].detail`, response.descripcion || []);
    } catch (error) {
      setNewToast({ type: 'ERROR', message: error.message });
    }
  };

  const recalculateSum = (value) => {
    let formattedTotalValue = value.toFixed(5).replace(/0+$/, '');

    if (formattedTotalValue.endsWith('.')) {
      formattedTotalValue = formattedTotalValue.slice(0, -1);
    }

    return formattedTotalValue;
  };
  const handleAddPP = () => {
    setFieldValue('programPoints', [...values.programPoints, { quantity: '', points: '' }]);
  };

  const handleSuprPP = (pLIndex) => {
    const newProgramPoints = values.programPoints.filter((_, index) => index !== pLIndex);

    let newTotalValue;

    if (newProgramPoints?.length > 0) {
      newTotalValue = newProgramPoints.reduce(
        (acc, curr) => parseFloat(acc) + parseFloat(curr.quantity),
        0
      );
    } else {
      newTotalValue = 0;
    }
    const valueTotalFixed = recalculateSum(newTotalValue);

    setFieldValue('programPoints', newProgramPoints);
    setFieldValue('totalValue', valueTotalFixed);
  };

  const handleChangeQuantity = useCallback(
    async (val, index) => {
      const { value } = val.target;

      if (validateDecimalInput(value, 5)) {
        const newTotalValue = values.programPoints?.reduce((acc, curr, i) => {
          if (i === index) {
            if (value === '') return acc;

            return parseFloat(acc) + parseFloat(value);
          }
          if (curr?.quantity === '') return parseFloat(acc);

          return parseFloat(acc) + parseFloat(curr.quantity);
        }, 0);

        const valueTotalFixed = recalculateSum(newTotalValue);

        await setFieldValue(`programPoints[${index}].quantity`, value);
        await setFieldValue('totalValue', valueTotalFixed);
      }
    },
    [values, setFieldValue]
  );

  const handleChangePoints = useCallback(
    async (val, index) => {
      const { value } = val.target;

      if (value === '0') return;

      if (validateDigitsInput(value, 4)) {
        await setFieldValue(`programPoints[${index}].points`, value);
      }
    },
    [setFieldValue]
  );

  const handleChangeCode = async (val, index) => {
    setFieldValue(`programPoints[${index}].subCode`, '');
    setFieldValue(`programPoints[${index}].detail`, '');

    await setFieldValue(`programPoints[${index}].code`, {
      ...val,
      nombre: val.label,
      id: val.value,
      label: val.label,
      value: val.value
    });
    fetchSubCodes(val, index);
  };

  const handleChangeSubCode = async (val, index) => {
    setFieldValue(`programPoints[${index}].detail`, '');
    await setFieldValue(`programPoints[${index}].subCode`, {
      ...val,
      nombre: val.label,
      id: val.value,
      label: val.label,
      value: val.value
    });

    fetchDetails(val, index);
  };
  const handleChangeCost = async (val, index) => {
    await setFieldValue(`programPoints[${index}].subCode`, '');
    await setFieldValue(`programPoints[${index}].code`, '');
    await setFieldValue(`programPoints[${index}].detail`, '');

    await setFieldValue(`programPoints[${index}].cost`, {
      ...val,
      nombre: val.nombreCorto,
      nombreLargo: val.nombre,
      id: val.value,
      label: `${val.costoClase} - ${val.fase}`,
      value: val.value
    });
    fetchCode(val, index);
  };

  useEffect(() => {
    fetchCost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificaPorCSA]);

  useEffect(() => {
    const newTotalValue = values?.programPoints.reduce((acc, curr) => {
      if (curr?.quantity === '') return parseFloat(acc);

      return parseFloat(acc) + parseFloat(curr.quantity);
    }, 0);

    const valueTotalFixed = recalculateSum(newTotalValue);

    setFieldValue('totalValue', valueTotalFixed);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.programPoints]);

  return {
    handleSuprPP,
    handleChangeQuantity,
    handleAddPP,
    handleChangePoints,
    handleChangeCode,
    handleChangeSubCode,
    handleChangeCost,
    costOptions
  };
};

export default useProgramPoint;
